import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import _ from 'underscore';
import { withTranslation } from 'react-i18next';
import CreateMarket from './CreateMarket';
class CreateMarketModal extends Component {
    render() {
        return (React.createElement(Modal, { show: this.props.show, onHide: this.props.onHide, dialogClassName: "modal-override", enforceFocus: false },
            React.createElement(Modal.Header, { closeButton: true },
                React.createElement("h4", { className: "pl-4" }, this.props.t('MARKET_DETAILS'))),
            React.createElement(Modal.Body, null,
                React.createElement(CreateMarket, { market: this.props.market, onHide: this.props.onHide, onSave: this.props.onSave, onEdit: this.props.onEdit, markets: this.props.markets }))));
    }
}
export default withTranslation()(CreateMarketModal);
